// import person1 from '../../images/person1.svg'
// import person2 from '../../images/person2.svg'
// import person3 from '../../images/person3.svg'
// import person4 from '../../images/person4.svg'

const data = [
    {
        id: 1,
        // image: person1,
        name: 'Chiamaka Nwosu',
        title: 'CEO, NovaTech Solutions',
        quote: "RefacTech's innovative solutions transformed our business operations, increasing efficiency by 40%. Their team is professional and responsive. We're grateful for their partnership!",
    },
    {
        id: 2,
        // image: person2,
        name: 'Emeka Okoro',
        title: ' Founder, Okoro Enterprises',
        quote: "RefacTech's expertise in software development helped us launch our e-commerce platform ahead of schedule. Their support has been invaluable. We highly recommend them!",
    },
    {
        id: 3,
        // image: person3,
        name: 'Adaeze Okonkwo',
        title: 'Managing Director, Green Earth Farms',
        quote: "RefacTech's technology solutions improved our farm's productivity and reduced costs. Their team's dedication to delivering quality service is impressive. We're thrilled with the results!",
    },
    {
        id: 4,
        // image: person4,
        name: 'Kofi Mensah',
        title: 'CEO, Mensah Logistics',
        quote: 'We needed a custom software solution to streamline our logistics operations, and Refactech delivered beyond our expectations.',
    },
];

export default data;